import device, {type DeviceType} from "current-device";

const DEVICE_NAMES: Record<DeviceType, string> = {
  desktop: "Компьютер",
  mobile: "Телефон",
  tablet: "Планшет",
  unknown: "не определено"
};

export function getDeviceName(): string {
  return DEVICE_NAMES[device.type] ?? DEVICE_NAMES.unknown;
}
